if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true
        },
      };

      const thumbs = document.querySelector(this.getAttribute('data-thumbs'));

      if (thumbs) {
        this.options.thumbs = {
          swiper: thumbs.swiper,
        };
      }

      this.swiper = new Swiper(this.querySelector('.swiper'), this.options);

      // Handle video thumbnail clicks
      this.setupVideoThumbnailClicks();

      // Add slide change event listener for video autoplay
      this.swiper.on('slideChangeTransitionEnd', (swiper) => {
        // Pause all videos first
        this.pauseAllVideos();
        
        // Get the active slide
        const activeSlide = swiper.slides[swiper.activeIndex];
        const videoContainer = activeSlide.querySelector('[data-media-type="video"]');
        
        if (videoContainer) {
          const mediaId = videoContainer.getAttribute('data-media-id');
          const mediaType = videoContainer.getAttribute('data-media-type');
          
          if (mediaId && mediaType === 'video') {
            setTimeout(() => {
              this.autoplayVideo(mediaId, mediaType);
            }, 100);
          }
        }
      });

      document.addEventListener('alexa:variant-change', (e) => {
        const mediaId = e.detail?.option?.dataset?.featuredMediaId;

        if (!mediaId) {
          return
        }

        const focusSlide = this.querySelector(`[data-media-id="${mediaId}"]`)?.getAttribute('data-index');

        if (focusSlide) {
          this.swiper.slideTo(focusSlide, 200);
        }
      });

      document.addEventListener('alexa:personalization-change', event => {
        const engravingImage = this.querySelector('[data-engraving-image]');
        const slideIndex = engravingImage?.getAttribute('data-index');

        if (engravingImage) {
          this.swiper.slideTo(slideIndex, 200);

          engravingImage.setAttribute('data-engraving-text', event.detail?.message)
        }
      });

      document.addEventListener('alexa:start-mobile-zoom', event => {
        this.swiper.allowTouchMove = false;
      });

      document.addEventListener('alexa:end-mobile-zoom', event => {
        this.swiper.allowTouchMove = true;
      });
    }

    setupVideoThumbnailClicks() {
      const thumbs = document.querySelector(this.getAttribute('data-thumbs'));
      if (!thumbs) return;

      // Add click listeners to ALL thumbnails (both images and videos)
      const allThumbs = thumbs.querySelectorAll('.swiper-slide');
      allThumbs.forEach(thumb => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          
          // First, pause any currently playing videos
          this.pauseAllVideos();
          
          // Check if this is a video thumbnail or image thumbnail
          const videoThumb = thumb.querySelector('.product__media-thumb-video');
          const imageThumb = thumb.querySelector('.product__media-thumb-image');
          
          let mediaId, mediaType;
          
          if (videoThumb) {
            mediaId = videoThumb.getAttribute('data-media-id');
            mediaType = videoThumb.getAttribute('data-media-type');
          } else if (imageThumb) {
            mediaId = imageThumb.getAttribute('data-media-id');
            mediaType = imageThumb.getAttribute('data-media-type');
          }
          
          if (mediaId) {
            // Find the corresponding slide in the main slider
            const targetSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
            if (targetSlide) {
              const slideIndex = targetSlide.getAttribute('data-index');
              this.swiper.slideTo(slideIndex, 300);
              
              // Only autoplay if this is a video thumbnail
              if (videoThumb && (mediaType === 'video' || mediaType === 'external_video')) {
                setTimeout(() => {
                  this.autoplayVideo(mediaId, mediaType);
                }, 350);
              }
            }
          }
        });
      });
    }

    pauseAllVideos() {
      // Pause all regular videos
      const allVideos = this.querySelectorAll('.video-player');
      allVideos.forEach(video => {
        if (!video.paused) {
          video.pause();
        }
      });
    }

    autoplayVideo(mediaId, mediaType) {
      const videoContainer = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!videoContainer) return;

      if (mediaType === 'video') {
        const video = videoContainer.querySelector('.video-player');
        if (video) {
          // Ensure mobile compatibility
          video.muted = true;
          video.playsInline = true;
          video.loop = true;
          
          // Attempt to play with error handling
          video.play().catch(error => {
            console.log('Video autoplay failed:', error);
            // Optionally show play button or handle gracefully
          });
        }
      }
    }
  }

  customElements.define('product-slider', ProductSlider);
}
